<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">
  <section class="section dashboard">
    <div class="pagetitle text-center mt-5">
      <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
        <i class="bi bi-check check-text"></i>
      </div>
      <h1>{{title}}</h1>
      <div class="div-page-description"><h5>{{message}}</h5></div>
      <a [routerLink]="['/manage-sites']" class="btn btn-primary">Manage Sites</a>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
